export const ROUTES = {
  home: '/',
  auth: '/admin/login',
  /** Deep-linked from Cognito forgot-password email (`email` + `code` query params). */
  resetPassword: '/admin/reset-password',
  /** Help + legacy temp-password path; new invites deep-link to `resetPassword`. */
  acceptInvite: '/admin/accept-invite',
  /** Shelter workspace home — `AppShellLayout`, any signed-in shelter persona. */
  admin: '/admin',
  adminPets: '/admin/pets',
  adminSettings: '/admin/settings',
  adminSettingsAccount: '/admin/settings/account',
  adminSettingsSecurity: '/admin/settings/security',
  adminSettingsShelterInfo: '/admin/settings/shelter-info',
  adminSettingsSubscription: '/admin/settings/subscription',
  adminSettingsBilling: '/admin/settings/billing',
  adminSettingsCustomization: '/admin/settings/customization',
  adminSettingsQuiz: '/admin/settings/quiz',
  adminSettingsAttributeMapping: '/admin/settings/attribute-mapping',
  adminSettingsTerms: '/admin/settings/terms',
  adminAnalytics: '/admin/analytics',
  /** Super Admin tools — nested under `RequireSuperAdmin`. */
  adminUsers: '/admin/users',
  /** Shelter Admins: roster in own org — `RequireShelterAdministrator`. */
  adminShelterUsers: '/admin/shelter/users',
  /** Shelter Admins: subscription tier / lifecycle — `RequireShelterAdministrator`. */
  adminShelterSubscription: '/admin/shelter/subscription',
  /** Stripe Checkout return — poll until webhook activates subscription. */
  adminShelterSubscriptionCheckoutSuccess:
    '/admin/shelter/subscription/checkout/success',
  /** Shelter Admins: analytics (placeholder) — `RequireShelterAdministrator`. */
  adminShelterAnalytics: '/admin/shelter/analytics',
  /** Shelter Admins: training (placeholder) — `RequireShelterAdministrator`. */
  adminShelterTraining: '/admin/shelter/training',
  adminShelters: '/admin/shelters',
  adminMatchQuestions: '/admin/match-questions',
  /** Super Admin only — subscription tiers (`RequireSuperAdmin`). */
  adminSubscriptions: '/admin/subscriptions',
  matchingPoc: '/matching/knn',
  /** Public adoption quiz per shelter roster (path segment is shelter UUID). */
  adoptShelterQuizRoot: '/adopt',
} as const;

export function adoptShelterQuizPath(shelterKey: string): string {
  return `${ROUTES.adoptShelterQuizRoot}/${encodeURIComponent(shelterKey)}`;
}
